import { render, staticRenderFns } from "./CheckoutTAndC.vue?vue&type=template&id=321d50a8&scoped=true&"
import script from "./CheckoutTAndC.vue?vue&type=script&lang=js&"
export * from "./CheckoutTAndC.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutTAndC.vue?vue&type=style&index=0&id=321d50a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d50a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
